import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
var _excluded = ["id", "value", "defaultValue", "form", "name", "onChange", "by", "disabled"],
    _excluded2 = ["id", "value", "disabled"];

var _ke;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import O, { createContext as J, useContext as V, useMemo as A, useReducer as se, useRef as j, useEffect as ue } from "react";
import { forwardRefWithAs as X, render as q, compact as de } from '../../utils/render.js';
import { useId as Q } from '../../hooks/use-id.js';
import { match as ce } from '../../utils/match.js';
import { useIsoMorphicEffect as fe } from '../../hooks/use-iso-morphic-effect.js';
import { Keys as D } from '../../components/keyboard.js';
import { focusIn as Y, Focus as I, FocusResult as Z, sortByDomNode as Te } from '../../utils/focus-management.js';
import { useFlags as me } from '../../hooks/use-flags.js';
import { Label as ye, useLabels as z } from '../../components/label/label.js';
import { Description as Re, useDescriptions as ee } from '../../components/description/description.js';
import { useTreeWalker as be } from '../../hooks/use-tree-walker.js';
import { useSyncRefs as te } from '../../hooks/use-sync-refs.js';
import { Hidden as ge, Features as Oe } from '../../internal/hidden.js';
import { attemptSubmit as Ee, objectToFormEntries as ve } from '../../utils/form.js';
import { getOwnerDocument as Pe } from '../../utils/owner.js';
import { useEvent as E } from '../../hooks/use-event.js';
import { useControllable as Ae } from '../../hooks/use-controllable.js';
import { isDisabledReactIssue7711 as re } from '../../utils/bugs.js';
import { useLatestValue as De } from '../../hooks/use-latest-value.js';
import { useDisposables as Ge } from '../../hooks/use-disposables.js';

var Ce = function (t) {
  return t[t.RegisterOption = 0] = "RegisterOption", t[t.UnregisterOption = 1] = "UnregisterOption", t;
}(Ce || {});

var ke = (_ke = {}, _defineProperty(_ke, 0, function _(r, o) {
  var t = [].concat(_toConsumableArray(r.options), [{
    id: o.id,
    element: o.element,
    propsRef: o.propsRef
  }]);
  return _objectSpread(_objectSpread({}, r), {}, {
    options: Te(t, function (p) {
      return p.element.current;
    })
  });
}), _defineProperty(_ke, 1, function _(r, o) {
  var t = r.options.slice(),
      p = r.options.findIndex(function (T) {
    return T.id === o.id;
  });
  return p === -1 ? r : (t.splice(p, 1), _objectSpread(_objectSpread({}, r), {}, {
    options: t
  }));
}), _ke),
    B = J(null);
B.displayName = "RadioGroupDataContext";

function oe(r) {
  var o = V(B);

  if (o === null) {
    var t = new Error("<".concat(r, " /> is missing a parent <RadioGroup /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(t, oe), t;
  }

  return o;
}

var $ = J(null);
$.displayName = "RadioGroupActionsContext";

function ne(r) {
  var o = V($);

  if (o === null) {
    var t = new Error("<".concat(r, " /> is missing a parent <RadioGroup /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(t, ne), t;
  }

  return o;
}

function Le(r, o) {
  return ce(o.type, ke, r, o);
}

var he = "div";

function Fe(r, o) {
  var t = Q(),
      _r$id = r.id,
      p = _r$id === void 0 ? "headlessui-radiogroup-".concat(t) : _r$id,
      T = r.value,
      v = r.defaultValue,
      S = r.form,
      m = r.name,
      M = r.onChange,
      _r$by = r.by,
      G = _r$by === void 0 ? function (e, i) {
    return e === i;
  } : _r$by,
      _r$disabled = r.disabled,
      C = _r$disabled === void 0 ? !1 : _r$disabled,
      H = _objectWithoutProperties(r, _excluded),
      y = E(typeof G == "string" ? function (e, i) {
    var n = G;
    return (e == null ? void 0 : e[n]) === (i == null ? void 0 : i[n]);
  } : G),
      _se = se(Le, {
    options: []
  }),
      _se2 = _slicedToArray(_se, 2),
      P = _se2[0],
      h = _se2[1],
      a = P.options,
      _z = z(),
      _z2 = _slicedToArray(_z, 2),
      N = _z2[0],
      R = _z2[1],
      _ee = ee(),
      _ee2 = _slicedToArray(_ee, 2),
      k = _ee2[0],
      U = _ee2[1],
      L = j(null),
      W = te(L, o),
      _Ae = Ae(T, M, v),
      _Ae2 = _slicedToArray(_Ae, 2),
      l = _Ae2[0],
      s = _Ae2[1],
      b = A(function () {
    return a.find(function (e) {
      return !e.propsRef.current.disabled;
    });
  }, [a]),
      F = A(function () {
    return a.some(function (e) {
      return y(e.propsRef.current.value, l);
    });
  }, [a, l]),
      d = E(function (e) {
    var n;
    if (C || y(e, l)) return !1;
    var i = (n = a.find(function (f) {
      return y(f.propsRef.current.value, e);
    })) == null ? void 0 : n.propsRef.current;
    return i != null && i.disabled ? !1 : (s == null || s(e), !0);
  });

  be({
    container: L.current,
    accept: function accept(e) {
      return e.getAttribute("role") === "radio" ? NodeFilter.FILTER_REJECT : e.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
    },
    walk: function walk(e) {
      e.setAttribute("role", "none");
    }
  });

  var x = E(function (e) {
    var i = L.current;
    if (!i) return;
    var n = Pe(i),
        f = a.filter(function (u) {
      return u.propsRef.current.disabled === !1;
    }).map(function (u) {
      return u.element.current;
    });

    switch (e.key) {
      case D.Enter:
        Ee(e.currentTarget);
        break;

      case D.ArrowLeft:
      case D.ArrowUp:
        if (e.preventDefault(), e.stopPropagation(), Y(f, I.Previous | I.WrapAround) === Z.Success) {
          var g = a.find(function (K) {
            return K.element.current === (n == null ? void 0 : n.activeElement);
          });
          g && d(g.propsRef.current.value);
        }

        break;

      case D.ArrowRight:
      case D.ArrowDown:
        if (e.preventDefault(), e.stopPropagation(), Y(f, I.Next | I.WrapAround) === Z.Success) {
          var _g = a.find(function (K) {
            return K.element.current === (n == null ? void 0 : n.activeElement);
          });

          _g && d(_g.propsRef.current.value);
        }

        break;

      case D.Space:
        {
          e.preventDefault(), e.stopPropagation();
          var u = a.find(function (g) {
            return g.element.current === (n == null ? void 0 : n.activeElement);
          });
          u && d(u.propsRef.current.value);
        }
        break;
    }
  }),
      c = E(function (e) {
    return h(_objectSpread({
      type: 0
    }, e)), function () {
      return h({
        type: 1,
        id: e.id
      });
    };
  }),
      _ = A(function () {
    return _objectSpread({
      value: l,
      firstOption: b,
      containsCheckedOption: F,
      disabled: C,
      compare: y
    }, P);
  }, [l, b, F, C, y, P]),
      ie = A(function () {
    return {
      registerOption: c,
      change: d
    };
  }, [c, d]),
      ae = {
    ref: W,
    id: p,
    role: "radiogroup",
    "aria-labelledby": N,
    "aria-describedby": k,
    onKeyDown: x
  },
      pe = A(function () {
    return {
      value: l
    };
  }, [l]),
      w = j(null),
      le = Ge();

  return ue(function () {
    w.current && v !== void 0 && le.addEventListener(w.current, "reset", function () {
      d(v);
    });
  }, [w, d]), O.createElement(U, {
    name: "RadioGroup.Description"
  }, O.createElement(R, {
    name: "RadioGroup.Label"
  }, O.createElement($.Provider, {
    value: ie
  }, O.createElement(B.Provider, {
    value: _
  }, m != null && l != null && ve(_defineProperty({}, m, l)).map(function (_ref, n) {
    var _ref2 = _slicedToArray(_ref, 2),
        e = _ref2[0],
        i = _ref2[1];

    return O.createElement(ge, _objectSpread({
      features: Oe.Hidden,
      ref: n === 0 ? function (f) {
        var u;
        w.current = (u = f == null ? void 0 : f.closest("form")) != null ? u : null;
      } : void 0
    }, de({
      key: e,
      as: "input",
      type: "radio",
      checked: i != null,
      hidden: !0,
      readOnly: !0,
      form: S,
      name: e,
      value: i
    })));
  }), q({
    ourProps: ae,
    theirProps: H,
    slot: pe,
    defaultTag: he,
    name: "RadioGroup"
  })))));
}

var xe = function (t) {
  return t[t.Empty = 1] = "Empty", t[t.Active = 2] = "Active", t;
}(xe || {});

var _e = "div";

function we(r, o) {
  var x;

  var t = Q(),
      _r$id2 = r.id,
      p = _r$id2 === void 0 ? "headlessui-radiogroup-option-".concat(t) : _r$id2,
      T = r.value,
      _r$disabled2 = r.disabled,
      v = _r$disabled2 === void 0 ? !1 : _r$disabled2,
      S = _objectWithoutProperties(r, _excluded2),
      m = j(null),
      M = te(m, o),
      _z3 = z(),
      _z4 = _slicedToArray(_z3, 2),
      G = _z4[0],
      C = _z4[1],
      _ee3 = ee(),
      _ee4 = _slicedToArray(_ee3, 2),
      H = _ee4[0],
      y = _ee4[1],
      _me = me(1),
      P = _me.addFlag,
      h = _me.removeFlag,
      a = _me.hasFlag,
      N = De({
    value: T,
    disabled: v
  }),
      R = oe("RadioGroup.Option"),
      k = ne("RadioGroup.Option");

  fe(function () {
    return k.registerOption({
      id: p,
      element: m,
      propsRef: N
    });
  }, [p, k, m, r]);
  var U = E(function (c) {
    var _;

    if (re(c.currentTarget)) return c.preventDefault();
    k.change(T) && (P(2), (_ = m.current) == null || _.focus());
  }),
      L = E(function (c) {
    if (re(c.currentTarget)) return c.preventDefault();
    P(2);
  }),
      W = E(function () {
    return h(2);
  }),
      l = ((x = R.firstOption) == null ? void 0 : x.id) === p,
      s = R.disabled || v,
      b = R.compare(R.value, T),
      F = {
    ref: M,
    id: p,
    role: "radio",
    "aria-checked": b ? "true" : "false",
    "aria-labelledby": G,
    "aria-describedby": H,
    "aria-disabled": s ? !0 : void 0,
    tabIndex: function () {
      return s ? -1 : b || !R.containsCheckedOption && l ? 0 : -1;
    }(),
    onClick: s ? void 0 : U,
    onFocus: s ? void 0 : L,
    onBlur: s ? void 0 : W
  },
      d = A(function () {
    return {
      checked: b,
      disabled: s,
      active: a(2)
    };
  }, [b, s, a]);
  return O.createElement(y, {
    name: "RadioGroup.Description"
  }, O.createElement(C, {
    name: "RadioGroup.Label"
  }, q({
    ourProps: F,
    theirProps: S,
    slot: d,
    defaultTag: _e,
    name: "RadioGroup.Option"
  })));
}

var Ie = X(Fe),
    Se = X(we),
    yt = Object.assign(Ie, {
  Option: Se,
  Label: ye,
  Description: Re
});
export { yt as RadioGroup };